import firebase from 'firebase/app';
import 'firebase/analytics';

// Your web app's Firebase configuration
var firebaseConfig = {
apiKey: "AIzaSyABubLGbll83BNNRo-BHWq_byzhcmL_wPM",
authDomain: "watchwhere.firebaseapp.com",
databaseURL: "https://watchwhere.firebaseio.com",
projectId: "watchwhere",
storageBucket: "watchwhere.appspot.com",
messagingSenderId: "286073662757",
appId: "1:286073662757:web:7e0533322dafacf47fbecc",
measurementId: "G-MKNTMF4BLJ"
};

// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default fire;